<div class="popup-container">
  <div
    class="role-skills-container"
    fxLayout="row"
    fxLayoutAlign="space-between center"
    [ngClass]="{ 'full-width': experienceIndiv && experienceIndiv.length > 1 }"
  >
    <div class="aide-op-container" *ngIf="experienceIndiv.length > 0" style="margin-right: 16px">
      <div class="nurse-type">
        <div *ngIf="experienceIndiv.length <= 2">{{ role?.name }}</div>
        <div class="default-select" *ngIf="experienceIndiv.length > 2">
          <div class="select-container">
            <select
              [(ngModel)]="role"
              [compareWith]="compareRole"
              (ngModelChange)="onRoleChange($event)"
              [disabled]="!!(!roles || (roles && roles.length === 0 && !role))"
            >
              <option *ngIf="roles && roles.length === 0 && role" [ngValue]="role" selected>{{ role.name }}</option>
              <ng-container *ngIf="roles && roles.length > 0">
                <option *ngFor="let role_ of roles" [ngValue]="role_">{{ role_.name }}</option>
              </ng-container>
            </select>
          </div>
        </div>
      </div>
      <div
        class="aide-op width-100"
        fxLayout="row"
        fxLayoutAlign="center start"
        *ngIf="experienceIndiv && experienceIndiv.length > 0"
      >
        <app-spider-chart
          *ngIf="!experienceIndivLoader && chartIndex >= 0 && experienceIndiv[chartIndex].roleData; else noData"
          class="width-100 radar-graph"
          [data]="experienceIndiv[chartIndex].roleData"
          [isCirc]="false"
          [canvasName]="'aosbc1' + chartIndex"
          [showDim]="true"
        >
        </app-spider-chart>

        <ng-template #noData>
          <div class="dancing-bars-charts" fxLayout="column" fxLayoutAlign="center center">
            <div class="waterfall-title">Aucune données pour ce rôle</div>
          </div>
        </ng-template>
      </div>
    </div>
    <div class="separator-vertical" *ngIf="experienceIndiv.length > 1"></div>
    <div class="aide-op-container" *ngIf="experienceIndiv.length > 1">
      <div class="nurse-type">
        <div *ngIf="experienceIndiv.length <= 2">{{ selectIndiv?.name }}</div>
        <div class="default-select" *ngIf="experienceIndiv.length > 2">
          <div class="select-container">
            <select
              [(ngModel)]="selectIndiv"
              [compareWith]="compareRole"
              (ngModelChange)="onSecondRoleChange($event)"
              [disabled]="!!(!selectIndiv || (roles && roles.length === 0 && !selectIndiv))"
            >
              <option *ngIf="roles && roles.length === 0 && selectIndiv" [ngValue]="selectIndiv" selected>
                {{ selectIndiv.name }}
              </option>
              <ng-container *ngIf="roles && roles.length > 0">
                <option *ngFor="let role_ of roles" [ngValue]="role_">{{ role_.name }}</option>
              </ng-container>
            </select>
          </div>
        </div>
      </div>
      <div
        class="aide-op width-100"
        fxLayout="row"
        fxLayoutAlign="center start"
        *ngIf="experienceIndiv && experienceIndiv.length > 1"
      >
        <app-spider-chart
          *ngIf="
            !experienceIndivLoader &&
              selectIndiv &&
              secondChartIndex >= 0 &&
              secondChartIndex < experienceIndiv.length &&
              experienceIndiv[secondChartIndex]?.roleData;
            else noSecondData
          "
          class="width-100 radar-graph"
          [data]="experienceIndiv[secondChartIndex].roleData"
          [isCirc]="true"
          [canvasName]="'aosbc2' + secondChartIndex"
          [showDim]="true"
        >
        </app-spider-chart>

        <ng-template #noSecondData>
          <div class="dancing-bars-charts" fxLayout="column" fxLayoutAlign="center center">
            <div class="waterfall-title">Aucune données pour ce rôle</div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
  <div class="separator-horizontal"></div>
  <div class="popup-bottom" fxLayout="row" style="justify-content: space-between">
    <app-smart-op-avatar [profile]="profile"></app-smart-op-avatar>
    <div fxLayout="row">
      <app-button text="Fermer" btnType="text" (click)="closePopup()"> </app-button>
      <app-button
        text="Voir toutes les compétences"
        icon="arrow_forward"
        btnType="outlined"
        iconPosition="right-icon"
        (click)="redirectToIndividualSkills()"
      >
      </app-button>
    </div>
  </div>
</div>
